import { Instance, SnapshotIn, applySnapshot, flow, types } from 'mobx-state-tree';

import { getUserOnboardingQuizz } from '@common/api/userOnboardingQuizzes';

import SlideUserItem from '../Slides/SlideUserItem';

const Service = types.model('OnboardingQuiz', {
	name: types.maybeNull(types.string),
});

const User = types.model('User', {
	id: types.optional(types.number, 0),
	first_name: types.maybeNull(types.string),
	last_name: types.maybeNull(types.string),
});
const OnboardingQuiz = types.model('OnboardingQuiz', {
	id: types.optional(types.number, 0),
	name: types.maybeNull(types.string),
	services: types.optional(types.array(Service), []),

	slides: types.optional(types.array(SlideUserItem), []),
});

const UserOnboardingItemResult = types
	.model('UserOnboardingItemResult', {
		id: types.maybeNull(types.number),
		user_id: types.maybeNull(types.number),
		onboarding_quiz_id: types.maybeNull(types.number),
		updated_at: types.maybeNull(types.string),
		onboarding_quiz: types.optional(OnboardingQuiz, {}),
		user: types.optional(User, {}),
	})
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		fetch: flow(function* (id: number) {
			self.loading = true;
			try {
				const result = yield getUserOnboardingQuizz(id || self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default UserOnboardingItemResult;

export interface IUserOnboardingItemResultModel extends Instance<typeof UserOnboardingItemResult> {}
export type IUserOnboardingItemResultIn = SnapshotIn<typeof UserOnboardingItemResult>;
